module.exports = {"id":"216814","name":"Salih Uçan","rating":"75","photo":"./data/images/photos/4/216814.png","club":{"name":"FC Sion","logo":"./data/images/clubs/FCSion.png"},"positions":["MC","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SalihUcan0.json
// module id = 3777
// module chunks = 0